const PUSH_MODIFICATION_ERRORS = 'PUSH_MODIFICATION_ERRORS'
const CLEAR_MODIFICATION_ERRORS = 'CLEAR_MODIFICATION_ERRORS'

export { PUSH_MODIFICATION_ERRORS, CLEAR_MODIFICATION_ERRORS }
